import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from 'services/api';
import { useAuth } from 'hooks/auth';
import { multiSelectorOptionsMapper, optionsMapper } from './utils';

type Company = {
  id: number;
  tradeName: string;
  addressComplement?: string;
  ie?: string;
};

export const useCompanyOptions = () => {
  const { token } = useAuth();

  const fetchCompanies = React.useCallback(async () => {
    const { data } = await api.get<Company[]>('/companies?asList=1', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map(company => {
      const { tradeName, addressComplement, ie, id } = company;
      const parts = [tradeName];

      if (addressComplement) {
        parts.push(addressComplement);
      }

      if (ie) {
        parts.push(`IE: ${ie}`);
      }

      return {
        value: id.toString(),
        label: parts.join(' - '),
      };
    });
  },[token])

  const { isPending, data } = useQuery({
    queryKey: ['fetchCompanies'],
    queryFn: () => fetchCompanies(),
  });

  return {
    singleSelectOptions: data ? data.map(optionsMapper) : [],
    multiSelectOptions: data ? data.map(multiSelectorOptionsMapper) : [],
    loading: isPending,
  };
};
